import { h } from 'preact'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import RadioBox from '../RadioBox'
import Checkbox from '../Checkbox'
import './styles.scss'

const SelectButton = ({
  children,
  name,
  value,
  onChange,
  type = 'radio',
  isChecked = false,
  className = '',
}) => {
  const classNames = classnames('select-button', className, {
    selected: isChecked,
  })

  const Element = type === 'radio' ? RadioBox : Checkbox

  return (
    <div className={classNames}>
      <Element
        label={children}
        inputProps={{
          id: `${name}-input`,
          name,
          value,
          checked: isChecked,
          onChange: e => onChange(e.target.value),
          'data-testid': `card-${value}`,
        }}
      />
    </div>
  )
}

SelectButton.propTypes = {
  children: PropTypes.element.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  type: PropTypes.string,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  className: PropTypes.string,
}

export default SelectButton
